import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../../WorkoutTemplateBuilder'

export default function WorkoutBuilderActionButton() {
    const { actionButtonText, workoutTemplateJSON, action } = useContext(WorkoutTemplateBuilderContext)

    if (actionButtonText !== null && action !== null) {
        return (
            <button
                type="button"
                className="w-full text-center rounded-full bg-orange-600 py-1 text-md font-semibold text-white shadow-sm disabled:bg-orange-700 hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                onClick={() => action(workoutTemplateJSON)}
            >
                {actionButtonText}
            </button>
        )
    }
}
